import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { Loader, PrimaryButton, SecondaryButton } from 'common/components';
import { ReactComponent as CloseIcon } from 'applicaiton/assets/close.svg';
import { StyledModal } from './styles';
import { Modal } from '@mui/material';

interface DeleteModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  isLoading: boolean;
}

const ConfirmEndAppointment: FC<DeleteModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  isLoading,
}) => {
  const { t } = useTranslation();
  return (
    <Modal open={isOpen}>
      <>
        {isLoading && <Loader />}
        <StyledModal>
          <CloseIcon onClick={onClose} />
          <h1>{t('appointment.confirmEndAppointment.titlePart1')} ?</h1>
          <div>
            <p> {t('appointment.confirmEndAppointment.description')}</p>
          </div>
          <section>
            <SecondaryButton onClick={onClose}>{t('cancel')}</SecondaryButton>
            <PrimaryButton onClick={onSubmit}>
              {t('appointment_types.delete_type.confirm')}
            </PrimaryButton>
          </section>
        </StyledModal>
      </>
    </Modal>
  );
};

export default ConfirmEndAppointment;
